import BasePage from "@Scripts/Pages/BasePage";

export default class WhereToBuyMapPage extends BasePage {
    public static async init() {
        await super.init();
    }
}